import { IEntityDto } from 'models/common';
import { IUserCard } from 'models/user/usercard';

type EntityIdString = string;

export enum Effect {
	Allow,
	Deny,
}

export enum PolicyType {
	/**
	 * Policy users = permission rules directly on user
	 */
	User,
	/**
	 * Policy permission set = aggregates permission rules for objects
	 */
	PermissionSet,
	/**
	 * Policy roles = aggregates permissionSets
	 */
	Role,
}

export interface IOfficeMember {
	officeId?: string;
	userId: string;
	name: string;
	jobTitle?: string;
	description?: string;
	picture?: string;
	id: string;
	rules?: IRule[];
	rulesId?: string;
	order?: number;
}
export interface IOfficeMemberRule {
	rule: IRule;
	id: string;
}

export interface IUserRole {
	role: 'Admin' | 'Member';
	objId: string; // id of the shop or office
	type: string;
	objInfo?: {
		addedDate: string;
		attributes: {
			isActive: boolean;
			Location: string;
			ShopId?: string;
			ShopName: string;
			ShopCode?: string;
			Status: number;
		};
		clob1: string;
		clob2: string;
		code: any;
		editorChoice: boolean;
		id: string;
		itemId: string;
		name: string;
		picture: string;
		publishDate: any;
		type: number;
		role: string;
	};
}

export interface IShopAdmin extends IUserCard {
	rule: IRule;
}

export interface IShopAdminRule {
	rule: IRule;
	id: string;
}

export interface IRule extends IEntityDto {
	id: string;
	/**
	 * Subject of rule, ex. User or PermissionSet or Role
	 */
	sub: EntityIdString;
	/**
	 * Object of rule, ex. specific flow, entity or view etc. or entire PersmissionSet
	 */
	obj: EntityIdString;
	/**
	 * Array of actions on object: create,read,update,delete,execute,all
	 */
	actions: string;
	effect: Effect;
	policyType: PolicyType;
}
